import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f1a1672"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "jiantou" }, null, -1))
const _hoisted_2 = { class: "ub fw title" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("智能引导")
const _hoisted_4 = { class: "ub ub-ver fw content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ub ub-ac ub-ps fw" }, "点击这里创建项目登记信息，", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ub ub-ac ub-ps fw" }, "开启项目管理工作。", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("知道了")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "ub ub-ac ub-ps ub-ver novice-div",
        style: _normalizeStyle({ top: _ctx.noviceTop + 'px', left: _ctx.noviceLeft + 'px' })
      }, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "title", {}, () => [
            _hoisted_3
          ], true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "content", {}, () => [
            _hoisted_5,
            _hoisted_6
          ], true)
        ]),
        (_ctx.showButton)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "ub ub-ac ub-pc btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = false))
            }, [
              _renderSlot(_ctx.$slots, "button", {}, () => [
                _hoisted_7
              ], true)
            ]))
          : _createCommentVNode("", true)
      ], 4))
    : _createCommentVNode("", true)
}